export default "/lineup-tool/assets/redux/ajax_loader2.gif";